"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateClient = void 0;
var Contact_1 = require("./Contact");
var Shared_1 = require("./Shared");
var Client = /** @class */ (function () {
    function Client() {
        this.region = "";
        this.primaryContact = new Contact_1.default();
        this.secondaryContact = new Contact_1.default();
        this.clientName = "";
        this.address1 = "";
        this.address2 = "";
        this.state = "";
        this.city = "";
        this.emergencyPhoneNumber = "";
        this.zipcode = "";
        this.seatLicences = 0;
        this.parkLicences = 0;
        this.subscriptionExpiry = null;
        //Filled in when needed
        this.currentSeats = 0;
        this.currentParks = 0;
    }
    return Client;
}());
exports.default = Client;
// Verifies whether a client record is OK. Throws exception if false
function validateClient(client) {
    if (!client.primaryContact || !client.secondaryContact) {
        throw Error("unknown error");
    }
    // Verification
    if (!client.primaryContact.fullName) {
        throw Error("Please enter a full name for the primary contact");
    }
    client.primaryContact.fullName = client.primaryContact.fullName.trim();
    if (!client.primaryContact.email || !Shared_1.validateEmail(client.primaryContact.email)) {
        throw Error("Please enter an email address for the primary contact");
    }
    client.primaryContact.email = client.primaryContact.email.trim();
    if (!client.clientName) {
        throw Error("Please enter the company name / city");
    }
    client.clientName = client.clientName.trim();
    if (!client.city) {
        throw Error("Please enter the city in the address section");
    }
    client.city = client.city.trim();
    if (!client.region) {
        throw Error("Please enter the country in the address section");
    }
    client.region = client.region.trim();
    if (!client.secondaryContact.fullName) {
        throw Error("Please enter a full name for the secondary contact");
    }
    client.secondaryContact.fullName = client.secondaryContact.fullName.trim();
    if (!client.secondaryContact.email || !Shared_1.validateEmail(client.secondaryContact.email)) {
        throw Error("Please enter an email address for the secondary contact");
    }
    client.secondaryContact.email = client.secondaryContact.email.trim();
}
exports.validateClient = validateClient;
